import React, { useState, useMemo, useEffect } from "react";
import {Form, Modal, Row, Spinner } from "react-bootstrap";
import { FaPlay, FaSearch, FaTimes, FaUndo } from "react-icons/fa";
import { Link, useParams,useNavigate } from "react-router-dom";
import { BASE_URL, access_token, auth_token } from "../../services/config";
import axios from "axios";
import { useSelector } from "react-redux";
import { getAnalytics,logEvent  } from 'firebase/analytics';

const SearchFilter = () => {
  const { seo_url } = useParams();
  const regionsData = useSelector((state) => state.region.regionsData);
  const firebaseAnalytics = getAnalytics();
  const {videodetailsitems} = useSelector(
    (state) => state.video_details
  );

  // console.log("videodetailsitemshows", videodetailsitems)
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searchItem, setSearchItem] = useState([]);
  const [finalSearchResults, setFinalSearchResults] = useState([]);
  const [loadMoreResultsData, setLoadMoreResultsData] = useState([]);
  const [loadMore, setLoadMore] = useState(false);
  const [showIcon, setShowIcon] = useState(false);
  const [count, setCount] = useState("");
  const getUserId = localStorage.getItem("user_id");
  const contentId = videodetailsitems?.content_id
  const [nextPage, setnextPage] = useState(1);
  var format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
  const navigate = useNavigate();

  const handleSearchQuery = useMemo(
    () => async (queryString) => {
      setSearchLoading(true);
      const trimmedQueryString = queryString.trim();
  
      const stringWithoutSpaces = trimmedQueryString.replace(/\s/g, "");
  
      const stringLengthWithoutSpaces = stringWithoutSpaces.length;
      if (
        trimmedQueryString !== "" && 
        !format.test(trimmedQueryString) &&
        stringLengthWithoutSpaces > 0
      ) {
        try {
          const selectedlng = "eng";
          const count = 24;
          const page = 0;
          const from = 0;
          const searchurl =
            BASE_URL +
            "search?q=" +
            encodeURIComponent(trimmedQueryString) +
            "&page_size=" +
            count +
            "&from=" +
            from +
            "&start_count=0&page=" +
            page +
            "&item_language=" +
            selectedlng +
            "&region=" +
            regionsData?.country_code2 +
            "&auth_token=" +
            auth_token +
            "&access_token=" +
            access_token;
          const response = await axios.get(searchurl);
          const resultsArray = Array.isArray(response.data.data.items)
            ? response.data.data.items
            : [response.data];
  
          const lowercaseQuery = trimmedQueryString.toLowerCase();
          const filteredResults = resultsArray.filter((result) =>
            result.title.toLowerCase().includes(lowercaseQuery)
          );
  
          setSearchResults(filteredResults || []);
          setSearchItem(
            response.data.data.items.map((item) => item.content_id)
          );
          setCount(response.data.data.count);
          setFinalSearchResults(response.data.data.items);
         
          // setSearchLoading(false);
        } catch (error) {
          // window.sdk.trackEvent("search_result_clicked", {
          //   video_name: seo_url,
          //   event_id: 6,
          //   keyword: trimmedQueryString,
          //   clicked: false,
          //   content_type: "video",
          //   device_id: "NA",
          //   city: regionsData?.city_name,
          //   state: regionsData?.state,
          //   ip: regionsData?.ip,
          //   postal_code: regionsData?.postal_code,
          //   content_value: contentId,
          //   u_id: getUserId,
          //   country: regionsData?.country_name,
          // });
       
          //  logEvent(firebaseAnalytics, 'search_result_clicked', {
          //   video_name: seo_url,
          //   keyword: trimmedQueryString,
          //   clicked: true,
          //   content_type: "video",
          //   content_value: contentId
          // });
          console.error("Error fetching search results:", error);
        } finally{
          setSearchLoading(false);
        }
      } else {
        setFinalSearchResults([]);
        setnextPage(1);
        // setLoadMore(false);
      }
    },
    []
  );


  const loadMoreResults = async () => {
    try {
      var searchurl = `${BASE_URL}search?q=${searchQuery}&page_size=24&from=${finalSearchResults.length}&start_count=0&page=${nextPage}&item_language=eng&region=${regionsData?.country_code2}&auth_token=${auth_token}&access_token=${access_token}`;
      try {
        setLoading(true);
        const response = await axios.get(searchurl);
        const additionalResults = Array.isArray(response.data.data.items)
          ? response.data.data.items
          : [response.data];

        // Combine existing results with new results
        const updatedResults = [...finalSearchResults, ...additionalResults];

        setFinalSearchResults(updatedResults);
        // setCount(updatedResults.length);
        setnextPage(nextPage + 1);
        setLoadMoreResultsData(response.data.data.items)
        console.log("ssss", response.data.data.items?.length)
        if(response.data.data.items?.length <= 5){
          setLoadMore(false);
        }else{
          setLoadMore(true);
        }
        setLoading(false);
        // Set loadMore to false if no more results
      } catch (error) {
        console.error("Error fetching data:", error?.message);
        // toast.error(error?.message);
      } finally {
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching additional search results:", error);
    }
  };

  const clearInputData = () => {
    setSearchResults([]);
    setFinalSearchResults([]);
    setSearchQuery("");
    setCount("");
    setSearchQuery("");
  };

  const handleSearchQueryChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
  
    if (query.trim().length > 0) {
      handleSearchQuery(query.trim()); // Trigger the search with trimmed query
      setShowIcon(true);
    } else {
      setShowIcon(false);
      setLoadMore(false);
      setSearchResults([]);
      setFinalSearchResults([]);
      setSearchQuery("");
      setCount("");
      setnextPage(1)
    }
  };
  
  useEffect(() => {
    // console.log("finalSearchResults", finalSearchResults)
    if(finalSearchResults.length < 5 || searchResults?.length === 0){
      setLoadMore(false);
    }else{
      setLoadMore(true);
    }
  }, [finalSearchResults, loadMoreResultsData, searchResults])

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);
  // console.log('searchResults query', searchResults)
  const handleSubmit = (e) => {
    e.preventDefault();
    handleSearchQuery(searchQuery);
    // setLoadMore(true);
    setShowIcon(true);
  };

  const handlesearchUrl = (seo_url) => {
      navigate(seo_url);
      // window.location.reload();
  };
  
  const itemSelected = (index,listItem) => {
    if (window && window.sdk && window.sdk.trackEvent) {
      window.sdk.trackEvent("search_result_clicked", {
        video_name: listItem.title,
        event_id: 6,
        keyword: searchQuery,
        clicked: true,
        content_type: listItem.media_type ? listItem.media_type : 'NA',
        content_value: listItem.content_value ? listItem.content_value : 'NA',
        device_id: "NA",
        city: regionsData?.city_name,
        state: regionsData?.state,
        ip: regionsData?.ip,
        postal_code: regionsData?.postal_code,
        u_id: getUserId,
        country: regionsData?.country_name,
        event_time:new Date().toISOString().slice(0, 19)
      });
    } else {
      console.error('Analytics SDK is not initialized yet.');
      // Handle initialization state or queue events for later
    }
    
    

          logEvent(firebaseAnalytics, 'search_result_clicked', {
            video_name: listItem.title,
            keyword:searchQuery,
            clicked: true,
            content_type: listItem.media_type ? listItem.media_type : 'NA',
            content_value: listItem.content_value ? listItem.content_value : 'NA'
          });

          if (window && window.sdk && window.sdk.trackEvent) {
            window.sdk.trackEvent("artwork_tapped", {
              source:"search",
              video_name:listItem.title,
              tray_name: searchQuery,
              content_type: listItem.media_type ? listItem.media_type : 'NA',
              position_within_tray: index+1,
              artwork_type: listItem.media_type ? listItem.media_type : 'NA',
         });
      
          } else {
            console.error('Analytics SDK is not initialized yet.');
            // Handle initialization state or queue events for later
          }
          
  };
  return (
    <div>
      <Form className="search-bar" onSubmit={(e) => e.preventDefault()}>
        <div onClick={handleShow}>
          <div variant="" id="button-addon1">
            <FaSearch className="icon-size" />
          </div>
        </div>
      </Form>

      <div className="popd">
        <Modal show={show} onHide={handleClose} className="entry">
          <Modal.Body>
            <div className="cancle-button">
              <Form onSubmit={handleSubmit}>
                <div className="search-botton-postion">
                  <FaSearch />
                </div>
                <Form.Group controlId="searchQuery">
                  <Form.Control
                    type="text"
                    placeholder="Search for Shows, Serials, Episodes, Movies, Recipes and Videos"
                    value={searchQuery}
                    onChange={handleSearchQueryChange}
                    autoFocus={true}
                    autoComplete="off"
                  />
                </Form.Group>
                {showIcon && (
                  <div className="clear-icon" onClick={clearInputData}>
                    <FaTimes />
                  </div>
                )}
              </Form>
              <p className="cancle-class" onClick={handleClose}>
                Cancel
              </p>
            </div>
            <div className="tetxt">
              {searchQuery ? (
                <h2 className="mt-5 mb-4">
                  {count} results for "{searchQuery}"
                </h2>
              ) : (
                ""
              )}


{searchLoading ? (
  <div
  className="text-center mt-4"
  style={{
    position: "fixed",
    top: "60%",
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 1050, 
  }}
>
  <Spinner animation="border" variant="danger" />
</div> ) : 
              <div className="row">
                {searchQuery && (count === 0 && finalSearchResults?.length === 0) ? <h4 className="text-center">No Data Found</h4>
              :  finalSearchResults.map((item, index) => {
                const maxCharacters = 24;
                let displayTitle = item?.title?.length > maxCharacters 
                ? item?.title?.substring(0, maxCharacters) + "..." 
                : item?.title;

                const dynamicUrl = item.seo_url;
                const ourseourl = dynamicUrl.startsWith("/")
                  ? dynamicUrl
                  : `/${dynamicUrl}`;

                return (
                  <div key={index} className="col-lg-2 col-md-3 col-sm-6 col-6">
                    <div className="carousel-card extraicon ">
                      {/* <Link to={ourseourl} onClick={handleClose}> */}
                        <div   onClick={() => {   itemSelected(index,item);
 handlesearchUrl(item.seo_url); handleClose();}}
>
                        <div className="extra lock-icon-class cms-container">
                          <div className="search-img-style">
                            <div className="thumbnailMovieCard searchimage">
                            <img
                              src={item.thumbnails.medium_16_9.url}
                              alt=""
                            />

                            <div className="iconcame">
                                <FaPlay />
                            </div>
                            </div>
                            <h4 className="text-white">{displayTitle}</h4>
                            {item?.access_control?.is_free === false && (
  <div className="lock-postion-class"></div>
)}
                            
                          </div>
                        </div>
                        </div>
                      {/* </Link> */}
                    </div>
                  </div>
                );
              })
              }
              </div>
  }
              
              <Row>
              </Row>
              {!searchLoading &&
              <div className="text-center paddin-25">
              {loading ? <Spinner /> : (
  <>
    {loadMore && (
      <button onClick={loadMoreResults} className="loadMoreBtn">
        Load More <FaUndo />
      </button>
    )}
  </>
)}

              </div>
              }
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};

export default SearchFilter;
